/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-pie': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm6.25 6.875h-5.625V3.781a6.25 6.25 0 015.625 5.594zM9.637 16.25a6.25 6.25 0 01-.262-12.469v5.625c0 .69.56 1.25 1.25 1.25h5.625a6.25 6.25 0 01-6.613 5.594z"/>'
  }
})
